const getStudioListResponse = (response) => {
  return response?.studios?.map((item) => {
    return {
      value: item?.id,
      label: `${item?.room} - ${item?.name}`,
    };
  });
};

export default getStudioListResponse;
